<template lang="pug">
section
  div
    | All applications for a sponsor licence
    | must meet following criteria:

  ul
    li
      | Eligibility
    li
      | Suitability
    li
      | Genuine vacancy,
      | salary and skill-level
    li
      | Criminal convictions
      | and civil penalties
    li
      | Pass pre-licence visits
      | (if conducted)

  br

  div
    | The
    |
    b standard processing time
    |
    | for applications is
    |
    b 8 weeks
    | ,
    | however for an extra £500
    | you might request for your application
    | to be processed in 5 working days.
</template>

<script>
export default {
  name: "decision_general",
};
</script>